import React from 'react';
import Container from '../../../components/UI/Container';
import ContactSectionWrapper from './contactSection.style.js';
import { enFr } from '../../../utils';
import { openCalendarModal } from '../../../utils/modal-helpers.jsx';

const EmailIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const PhoneIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const ContactSection = () => {
  return (
    <ContactSectionWrapper id="contact">
      <Container>
        <div className="sectionTitle">
          <h2>{enFr('Start a Conversation', 'Démarrons une conversation')}</h2>
          <p>
            {enFr(
              'Have a project in mind or ready to explore what\u2019s possible?',
              'Vous avez un projet en tête ou envie d\u2019explorer ce qui est possible?'
            )}
          </p>
          <p>
            {enFr(
              'Choose how you\u2019d like to connect.',
              'Choisissez comment vous souhaitez nous contacter.'
            )}
          </p>
        </div>

        <div className="contactRow">
          <div className="col">
            <div className="contactCard">
              <div className="icon-wrapper">
                <EmailIcon />
              </div>
              <h3>{enFr('Email Us', 'Envoyez-nous un courriel')}</h3>
              <p className="emailDescription">
                {enFr(
                  'Have a question about our services? We respond within one business day.',
                  'Vous avez une question sur nos services? Nous répondons dans un délai d\u2019un jour ouvrable.'
                )}
              </p>
              <a
                className="emailLink"
                href="mailto:info@awakensolutions.com"
              >
                info@awakensolutions.com
              </a>
            </div>
          </div>

          <div className="col">
            <div className="contactCard">
              <div className="icon-wrapper">
                <PhoneIcon />
              </div>
              <h3>{enFr('Call Us', 'Appelez-nous')}</h3>
              <p className="emailDescription">
                {enFr(
                  'Prefer to talk? Give us a call during business hours (Montreal, Eastern Time).',
                  'Vous préférez parler? Appelez-nous pendant les heures de bureau (Montréal, heure de l\u2019Est).'
                )}
              </p>
              <a
                className="emailLink"
                href="tel:+15149954967"
              >
                +1 514 995 4967
              </a>
            </div>
          </div>

          <div className="col">
            <div className="calendarCard">
              <div className="icon-wrapper">
                <CalendarIcon />
              </div>
              <h3>{enFr('Book a Call', 'Réserver un appel')}</h3>
              <p className="calendarDescription">
                {enFr(
                  'Ready to discuss your project? Schedule a call at a time that works for you.',
                  'Prêt à discuter de votre projet? Planifiez un appel au moment qui vous convient.'
                )}
              </p>
              <button
                className="bookingButton"
                onClick={openCalendarModal}
                type="button"
              >
                {enFr('Schedule Now', 'Planifier maintenant')}
                <ArrowIcon />
              </button>
            </div>
          </div>
        </div>
      </Container>
    </ContactSectionWrapper>
  );
};

export default ContactSection;
